"use strict";

define('libs/format/date',['require','exports','module','moment','./empty'],function (require, exports, module) {
  var moment = require('moment');
  var emptyFormatter = require('./empty');
  var dateFormatter = function dateFormatter(format, emptyValue, options) {
    var useCalendarDate = format === 'CALENDAR_DATE',
      useCalendarTime = format === 'CALENDAR_TIME',
      emptyFunction = emptyFormatter(emptyValue, options);
    format = format || 'L';
    return function (value) {
      if (value) {
        if (useCalendarDate) {
          var now = moment(),
            sod = now.startOf('day'),
            diff = moment(value).diff(sod, 'days', true),
            output = null,
            calendarFormat = diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
          switch (calendarFormat) {
            case 'sameDay':
              output = 'Today';
              break;
            case 'nextDay':
              output = 'Tomorrow';
              break;
            case 'lastDay':
              output = 'Yesterday';
              break;
            case 'lastWeek':
            case 'nextWeek':
              output = moment(value).from(moment());
              output = output.slice(0, 1).toUpperCase() + output.slice(1);
              break;
            case 'sameElse':
              output = moment(value).format('L');
              break;
          }
          return output;
        }
        if (useCalendarTime) {
          var output = moment(value).calendar();
          if (output.slice(0, 1) == 'l') {
            output = output.slice(0, 1).toUpperCase() + output.slice(1);
          }
          return output;
        }
        return moment(value).format(format);
      }
      return emptyFunction.apply(this, arguments);
    };
  };
  module.exports = dateFormatter;
});

